/**
 * Build a `/cdn` URL with an optional on-demand resize width — local copy of
 * apps/web's helper (no cross-app imports). Allowed widths mirror the worker
 * whitelist (64/480/800/1280/2048); `v` is the client cache-buster token and
 * must stay in sync with apps/web/src/lib/cdn.ts.
 */
const CDN_VERSION = "2";

export function cdnUrl(keyOrUrl: string, opts?: { w?: number }): string {
  const base = keyOrUrl.startsWith("/cdn/") || keyOrUrl.startsWith("http")
    ? keyOrUrl
    : `/cdn/${keyOrUrl}`;
  if (!opts?.w) return base;
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}w=${opts.w}&v=${CDN_VERSION}`;
}
